import { Injectable } from '@angular/core';
import { ApiService, JobCreate } from '@bt/core';
import { IResponse } from '@bt/shared';
import { JobInfo } from "@bt/core";

/**
 * Сервис управления хранимыми задачами
 */
@Injectable()
export class StoredJobService {
  /**
   * Корневой api-адрес сервиса
   * @private
   */
  private readonly apiUri: string = "api/stored-job";

  constructor(private api: ApiService) {
  }

  /**
   * Возвращает запрос на получение списка задач
   */
  public getAllStoredJobs(group?: string): Promise<IResponse<JobInfo<any>[]>> {
    return this.api.get<JobInfo<any>[]>(
        this.buildApiUri("list"),
        { "groupJob": group })
      .toPromise();
  }

  /**
   * Отправляет запрос на создание задачи
   * @param parameters
   */
  public createStoredJob(parameters: JobCreate): Promise<IResponse<{}>> {
    return this.api.post<{}>(
        this.buildApiUri("create"),
        parameters)
      .toPromise();
  }

  /**
   * Отправляет запрос на обновление параметров задачи
   * @param parameters
   */
  public updateStoredJob(parameters: JobCreate): Promise<IResponse<{}>> {
    return this.api.post<{}>(this.buildApiUri("update"), parameters)
      .toPromise();
  }

  /**
   * Отправляет запрос на удаление задачи
   * @param name Название задачи
   * @param group Группа задачи
   */
  public deleteStoredJob(name: string, group: string): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(
        this.buildApiUri("delete"),
        { "jobName": name, "jobGroup": group })
      .toPromise();
  }

  /**
   * Отправляет запрос на остановку выполнения задачи
   * @param name Название задачи
   * @param group Группа задачи
   */
  public pauseStoredJob(name: string, group: string): Promise<IResponse<any>> {
    return this.api.get<boolean>(
        this.buildApiUri("pause"),
        { "jobName": name, "jobGroup": group })
      .toPromise();
  }

  /**
   * Отправляет запрос на продолжение выполнения задачи
   * @param name Название задачи
   * @param group Группа задачи
   */
  public resumeStoredJob(name: string, group: string): Promise<IResponse<any>> {
    return this.api.get<boolean>(
        this.buildApiUri("resume"),
        { "jobName": name, "jobGroup": group })
      .toPromise();
  }

  /**
   * Формирует ссылку для запроса
   * @param uriString Команда api-запроса
   */
  private buildApiUri(uriString: string): string {
    if (!uriString.startsWith("/"))
      uriString = "/" + uriString;

    return this.apiUri + uriString;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/storedJob.service.ts